<template>
  <div class="details-page">
    <h3 class="article_title">{{ title }}</h3>
    <div class="article-sub">
      <div>阅读：{{ viewcount }}</div>
      <div class="lineDiv"></div>
      <div>转发：{{ fwdcount }}</div>
      <div style="flex: 1; text-align: right">{{ getFormatDate() }}</div>
    </div>
    <div class="article_content" v-html="content"></div>
    <!-- 原文链接/免责声明 -->
    <div class="article_statement">
      <div class="link" @click="openLink">原文链接</div>
      <div class="statement" @click="openState">
        <span>免责声明</span>
        <img src="../imgs/open.png" alt />
      </div>
    </div>

    <div class="statement_content" v-if="openStatement">
      <p>本文内容编辑整理均来源于网络，版权归原作者所有，如有涉及侵权，请及时联系我们，我们会立即删除，特此声明。</p>
      <div class="btn" @click="showSheet = true">
        <img src="../imgs/complaint.png" alt />
        <span>投诉</span>
      </div>
    </div>
    <van-action-sheet
      v-model="showSheet"
      :round="false"
      :actions="actions"
      @select="complaint"
      cancel-text="取消"
      description="问题内容"
      close-on-click-action
    />
  </div>
</template>

<script>
import URL from "@/api/api";
import wx from "weixin-js-sdk";
import { Toast, Dialog, ActionSheet } from "vant";
export default {
  name: "articleDetails",
  data() {
    return {
      articleId: "",
      title: "",
      refname: "",
      reflink: "",
      viewcount: 0,
      fwdcount: 0,
      artctype: "",
      publishDate: "",
      content: "",
      baseUrl: "",
      shareLink: "",
      shareImg: "",
      cardInfo: "",
      openId: sessionStorage.getItem("openId"),
      firstTransferPerson: "",
      lastTransferPerson: "",
      customerName: "",
      customerPhoneNumber: "",
      headerImg: "",
      unionid: "",
      lblName: "",
      artcsummary: "",
      showLongBtn: "y",
      showCard: false,
      isReg: false,
      openStatement: false,
      showSheet: false,
      articleLink: false,
      url: "",
      actions: [
        { id: 0, name: "举报非此品牌内容", className: "one" },
        { id: 1, name: "举报文章内容质量差", className: "one" },
        { id: 2, name: "涉及欺诈、色情、版权问题", className: "one" },
      ],
      isAdmin: false,
    };
  },
  computed: {
    transid: () => {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
  },
  created() {
    var that = this;
    that.$nextTick(function () {
      that.unionid = localStorage.getItem("unionid");
    });
  },
  mounted() {
    if (location.hostname == 'dtfcloud.com') {
      this.url = 'https://dtfcloud.com/'
    } else {
      this.url = 'https://jzt.dtfcloud.com/'
    }
    var that = this;
    setTimeout(function () {
      that.checkPower();
    }, 500);

    this.unionid = localStorage.getItem("unionid");
    that.showLongBtn = this.$route.query.showLongBtn;
    (this.showLongBtn);
  },
  methods: {
    checkPower() {
      let that = this;
      this.$fetchPost(URL.checkAuthority.url, {
        unionid: this.getUrlParams("firstTransferPerson"),
      }).then((res) => {
        if (res) {
          if (res.data.data) {
            this.isAdmin = true;
          }
          this.articleId =
            this.$route.query.articleId || sessionStorage.getItem("articleId");
          this.firstTransferPerson = this.getUrlParams("firstTransferPerson")
            ? this.isAdmin
              ? localStorage.getItem("unionid")
              : this.getUrlParams("firstTransferPerson")
            : localStorage.getItem("unionid");
          this.lastTransferPerson = this.getUrlParams("lastTransferPerson");
          this.first_openid = this.getUrlParams("first_openid")
            ? this.isAdmin
              ? sessionStorage.getItem("openId")
              : this.getUrlParams("first_openid")
            : sessionStorage.getItem("openId");
          if (location.hostname === "zf.dtfcloud.com") {
            that.baseUrl = "https://zf.dtfcloud.com/";
            that.appId = "wxae0168c583647722";
          } else {
            that.baseUrl = "https://jzt.dtfcloud.com/test-zfkj/";
            that.appId = "wxae0168c583647722";
          }
          let url =
            that.baseUrl +
            "#/articleDetails?articleId=" +
            that.articleId +
            "&firstTransferPerson=" +
            that.firstTransferPerson +
            "&lastTransferPerson=" +
            localStorage.getItem("unionid") +
            "&type=ART&first_openid=" +
            sessionStorage.getItem("openId");
          that.shareLink =
            url
          setTimeout(function () {
            sessionStorage.setItem("articleId", that.articleId);
            that.openId =
              sessionStorage.getItem("openId") || that.$route.query.openId;
            that.getDetails();
          }, 500);
        }
      });
    },
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    complaint(e) {
      this.$fetchPost(URL.insertComplaints.url, {
        artcid: this.articleId,
        artctype: this.artctype,
        userid: this.unionid,
        complain: e.name,
      }).then((res) => {
      });
      Toast("举报成功");
    },
    openLink() {
      window.location.href = this.reflink;
    },
    openState() {
      this.openStatement = !this.openStatement;
      this.articleLink = false;
    },
    cancel: function () {
      if (
        this.$route.query.canBack != "y" &&
        this.$route.name == "articleDetails"
      ) {
        window.WeixinJSBridge.call("closeWindow");
      } else {
        this.$router.go(-1);
      }
    },

    getDetails() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true,
      });
      that.$fetchGet(URL.articleDetails.url, {
        artcId: that.articleId
      }).then((res) => {
        Toast.clear();
        if (res.data.code === 20000) {
          that.title = res.data.data.title;
          this.refname = res.data.data.refname;
          this.viewcount = res.data.data.viewcount;
          this.fwdcount = res.data.data.fwdcount;
          this.publishDate = res.data.data.pubdate;
          this.content = res.data.data.content;
          // this.share(this.title,'',this.shareLink,this.shareImg)
          that.title = res.data.data.title;
          that.refname = res.data.data.refname;
          that.reflink = res.data.data.reflink;
          that.publishDate = res.data.data.pubdate;
          that.content = res.data.data.content;
          that.shareImg = res.data.data.coverlink;
          that.artcsummary = res.data.data.friendsummary;
          that.artctype = res.data.data.artctype;
          that.share(
            that.title,
            that.artcsummary,
            that.shareLink,
            res.data.data.coverlink
          );
          setTimeout(() => {
            var activeData = {
              transId: that.transid,
              timeFlag: that.getTimeStamp(2),
              actionType: "visit",
              action: "ACT6",
              userId: localStorage.getItem("unionid")
                ? localStorage.getItem("unionid")
                : sessionStorage.getItem("openId"),
              unionid: localStorage.getItem("unionid"),
              funcId: that.getUrlParams("articleId"),
              url: window.location.href,
              fromUrl: document.referrer,
              productId: that.getUrlParams("type"),
              nikename: sessionStorage.getItem("nickname"),
              headImgUrl: sessionStorage.getItem("headImgUrl"),
              buttonId: sessionStorage.getItem("firstTransferPerson"),
              accessType: "V1",
              source: "wx",
              customerId: localStorage.getItem("unionid"),
              // customerId:that.unionid,
              funcName: res.data.data.title,
              viewDuration: "5",
            };
            that.submitUserActive(activeData);
            that.submitVisitedTimes(activeData);
            //代码
          }, 1500);
        }
      });
    },
    getFormatDate() {
      let publishDate = "";
      const date = new Date(Date.parse(new Date()));
      const Y = date.getFullYear() + "-";
      const M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      const D =
        date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate();
      publishDate = Y + M + D;
      return publishDate;
    },

    checkAuth() {
      var that = this;
      that.firstTransferPerson = localStorage.getItem("unionid");
      let url =
        that.baseUrl +
        "#/articleDetails?articleId=" +
        that.articleId +
        "&firstTransferPerson=" +
        that.firstTransferPerson +
        "&lastTransferPerson=" +
        localStorage.getItem("unionid");
      that.shareLink =
        url
      that.share(that.title, that.artcsummary, that.shareLink, that.shareImg);
    },
    share(title, desc, shareLink, shareImg) {
      let that = this;
      let url = location.href.split("#")[0];
      that.$fetchGet(URL.articleShare.url, { url: url }).then(res => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: [
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
            "hideMenuItems",
          ], // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            success: function () {
              console.log("adsdasdasdasdasd")
              // 用户确认分享后执行的回调函数
              that.$fetchPost(URL.articleShareSuccess.url, {
                temp: 0 || '0',
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.firstTransferPerson,
                lastTransferPerson: localStorage.getItem("unionid")
                  ? localStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                activityType: "ART",
                agtid: localStorage.getItem("unionid")
                  ? localStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                unionid: localStorage.getItem("unionid"),
                nikename: localStorage.getItem("nickname"),
                headImgUrl: localStorage.getItem("headimgurl"),
                wechatNumber:
                  localStorage.getItem("unionid") != that.firstTransferPerson
                    ? that.getUrlParams("lastTransferPerson")
                    : "", //上次转发人
                source: "wx",
                customerId: localStorage.getItem("unionid"),
                funcName: title,
              });
            },
            cancel: function () { },
          });
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标
            success: function () {
              console.log("ok")
              // 用户确认分享后执行的回调函数
              that.$fetchPost(URL.articleShareSuccess.url, {
                temp: 0 || '0',
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.firstTransferPerson,
                lastTransferPerson: localStorage.getItem("unionid")
                  ? localStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                activityType: "ART",
                agtid: localStorage.getItem("unionid")
                  ? localStorage.getItem("unionid")
                  : sessionStorage.getItem("openId"),
                unionid: localStorage.getItem("unionid"),
                nikename: localStorage.getItem("nickname"),
                headImgUrl: localStorage.getItem("headimgurl"),
                wechatNumber:
                  localStorage.getItem("unionid") != that.firstTransferPerson
                    ? that.getUrlParams("lastTransferPerson")
                    : "", //上次转发人
                source: "wx",
                customerId: localStorage.getItem("unionid"),
                funcName: title,
              });
            },
          });
        });
      });
    },
    getTimeStamp: function (format) {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      //精确到天
      if (format == 1) {
        time = year + "-" + month + "-" + date;
      }
      //精确到分
      else if (format == 2) {
        time =
          year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      }
      return time;
    },
    //统计时长
    submitVisitedTimes(data) {
      let that = this;
      //   let data = {
      //     transId: that.transid,
      //     viewDuration: 5
      //   };
      that.$fetchPost(URL.subViewduration.url, data).then(res => {
        if (res.ret == "00000") {
          setTimeout(function () {
            that.submitVisitedTimes(data);
          }, 5000);
        }
      });
    },
    //
    submitUserActive: function (obj) {
      let that = this;
      that.$fetchPost(URL.userActive.url, obj).then(res => {
      });
      // alert('提交成功')
    },
  },
};
</script>

<style lang="less" scoped>
.matchTitle {
  width: 86%;
  position: absolute;
  bottom: 20px;
  left: 50%;
  bottom: 20px;
  border-radius: 16px;
  padding: 16px 12px;
  transform: translate(-50%, 0);
  background: #fff;
  text-align: center;
  p:nth-child(1) {
    font-size: 16px;
    color: black;
    font-weight: bold;
  }
  .content {
    background: #f8f8f8;
    width: 100%;
    min-height: 50px;
    font-size: 14px;
    line-height: 2;
    color: #383838;
    padding: 23px 12px;
    margin: 10px 0;
    // border-radius: 4px;
  }
  p:nth-child(3) {
    font-size: 12px;
    color: #858585;
  }
}
.article_link {
  width: 100%;
  color: #95c6f8;
  font-size: 12px;
  line-height: 1.6;
  padding: 0 10px;
  word-wrap: break-word;
}
.van-action-sheet__gap {
  height: 2px;
}
.van-action-sheet__description {
  color: #383838;
  font-size: 16px;
  font-weight: bold;
}
.one {
  color: #383838;
  font-size: 14px;
}
.article_statement {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 10px;
  padding: 0 10px;
  .link {
    font-size: 12px;
    line-height: 12px;
    color: #458ad1;
  }
  .statement {
    display: flex;
    align-items: center;
    span {
      font-size: 12px;
      line-height: 12px;
      color: #d0d0d0;
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.statement_content {
  text-align: center;
  padding: 0 10px;
  p {
    font-size: 12px;
    line-height: 1.6;
    color: #d8d8d8;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    border: 2px solid #d8d8d8;
    margin: 20px auto;
    img {
      width: 20px;
      height: 20px;
    }
    span {
      color: #ccc8c8;
      font-size: 12px;
      line-height: 12px;
    }
  }
}

.details-page {
  padding: 0 23px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  overflow-x: hidden;
  padding-bottom: 60px;
  background: #fff;
  .article_title {
    padding: 10px 0;
    font-size: 18px;
    text-align: left;
  }
  .article-sub {
    // margin-bottom: 20px;
    font-size: 13px;
    line-height: 18px;
    display: flex;
    color: #a6a6a6;
    div {
      margin-right: 4px;
      white-space: nowrap;
    }
    div.lineDiv {
      height: 10px;
      width: 1px;
      margin-top: 4px;
      background: #a6a6a6;
    }
    div:nth-child(1) {
      color: #2b6a87;
    }
  }
  /deep/ .article_content {
    letter-spacing: 3px;
    line-height: 1.6 !important;
    font-size: 17px;
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
      font-size: 16px;
      font-weight: 500;
    }
    span{
      letter-spacing: .034em;
    }
    p {
      // margin: 16px 0 !important;
      img {
        width: 100% !important;
        margin: 0 auto !important;
      }
    }
    img {
      width: 100% !important;
      margin: 0 auto !important;
    }
  }
  .van-overlay {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    .tipBox {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      background: #fff;
      padding-bottom: 64px;
      h2 {
        color: #1a1a1a;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
      }
      .closeBtn {
        width: 40px;
        height: 40x;
        position: absolute;
        right: 4px;
        top: 0;
        img {
          width: 10px;
          margin: 15px auto;
        }
      }
      p {
        color: #1a1a1a;
        padding: 0 16px;
        font-size: 12px;
      }
      .bot_content {
        position: absolute;
        bottom: 16px;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        p {
          padding: 0;
          line-height: 31px;
          color: #ff6927;
          margin-left: 16px;
        }
        div {
          margin-right: 16px;
          width: 72px;
          height: 31px;
          background: linear-gradient(270deg, #ff4c32 0%, #ff983f 100%);
          opacity: 1;
          border-radius: 15px;
          line-height: 31px;
          text-align: center;
          color: #fff;
        }
      }
    }
  }
}


// body {
// 	text-underline-position: under; -webkit-text-decoration-skip-ink: none;
// 	text-decoration-skip-ink: none
// }
// @supports(-webkit-overflow-scrolling: touch) {
// 	body {
// 		text-underline-position: initial;
// 		text-underline-offset: .24em
// 	}
// }
// html {
// 	-ms-text-size-adjust: 100% ; -webkit-text-size-adjust: 100% ;
// 	line-height: 1.6;
// }
// input:matches([type = "button"], [type = "submit"], [type = "reset"]), input[type = file]::-webkit-file-upload-button, button {
// 	font-family: inherit
// }
// body {
// 	-webkit-touch-callout: none;
// 	color: #222;background-color:#ededed;
// 	letter-spacing: .034em
// }
// body.wx_wap_page {
// 	font-family: system-ui, -apple- ystem, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans - serif
// }
// h1, h2, h3, h4, h5, h6 {
// 	font-weight: 400;
// 	font-size: 16px
// }*{
// 	margin: 0;padding: 0
// }
// a {
// 	color: #576b95;text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.wx-edui-video_source_link{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;padding:14px 16px;background-color:#f7f7f7;background-color: var(--weui-BG-1);border-radius: 8px;font-size: 15px;line-height: 18px;width: 100% ;box-sizing: border-box;margin-bottom: 8px;position: relative;
// }


// * {
//   margin: 0;
//   padding: 0;
// }

// html,
// body,
// #app {
//   height: 100%;
//   font-family: "PingFangSC Regular", "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   background: #fff;
// }

// html,
// body,
// div,
// p,
// ul,
// li,
// img,
// h1,
// h2,
// h3,
// h4,
// h5,
// h6 {
//   box-sizing: border-box;
// }

// img {
//   max-width: 100%;
//   display: block;
// }

// .loading {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   z-index: 999999;
// }

</style>
